
import { Action, createReducer, on } from '@ngrx/store';
import { EntityEspeciesCertificablesAddFailure, EntityEspeciesCertificablesAddRequest, EntityEspeciesCertificablesAddSuccess, EntityEspeciesCertificablesDeleteFailure, EntityEspeciesCertificablesDeleteRequest, EntityEspeciesCertificablesDeleteSuccess, EntityEspeciesCertificablesLoadFailure, EntityEspeciesCertificablesLoadRequest, EntityEspeciesCertificablesLoadSuccess, EntityEspeciesCertificablesUpdateFailure, EntityEspeciesCertificablesUpdateRequest, EntityEspeciesCertificablesUpdateSuccess } from './entity-especies-certificables.actions';
import { EntityEspeciesCertificablesState, EntityEspeciesCertificablesAdapter, initialState } from './entity-especies-certificables.state';

const reducer = createReducer(
  initialState,
  on(EntityEspeciesCertificablesLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(EntityEspeciesCertificablesAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(EntityEspeciesCertificablesUpdateRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(EntityEspeciesCertificablesDeleteRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(EntityEspeciesCertificablesLoadSuccess, (state, { items }) =>
    EntityEspeciesCertificablesAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  on(EntityEspeciesCertificablesLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error
  })),
  on(EntityEspeciesCertificablesAddSuccess, (state, { item }) => {
    return EntityEspeciesCertificablesAdapter.addOne(item, {
      ...state,
      isLoading: false,
      error: null
    });
  }),
  on(EntityEspeciesCertificablesUpdateSuccess, (state, { item }) => {
    return EntityEspeciesCertificablesAdapter.upsertOne(item, {
      ...state,
      isLoading: false,
      error: null
    });
  }),
  on(EntityEspeciesCertificablesDeleteSuccess, (state, { item }) => {
    return EntityEspeciesCertificablesAdapter.removeOne(item.id, {
      ...state,
      isLoading: false,
    });
  }),
  on(EntityEspeciesCertificablesAddFailure, (state) => ({
    ...state,
    isLoading: false,
    error: null
  })),
  on(EntityEspeciesCertificablesDeleteFailure, (state) => ({
    ...state,
    isLoading: false,
    error: null
  })),
  on(EntityEspeciesCertificablesUpdateFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error
  })),
);

export function EntityEspeciesCertificablesReducer(
  state: EntityEspeciesCertificablesState | undefined,
  action: Action
) {
  return reducer(state, action);
}
